import React from 'react';
import { useGoalsSavedFixtures, useGoalsWatchlists } from '../../swr-config';

interface GoalsSavedFixturesProps {
  onSelectFixture: (fixtureId: number) => void;
  onBack: () => void;
}

export function GoalsSavedFixtures({ onSelectFixture, onBack }: GoalsSavedFixturesProps) {
  const { data: savedFixtures, isLoading: loadingFixtures } = useGoalsSavedFixtures();
  const { data: watchlists, isLoading: loadingWatchlists } = useGoalsWatchlists();

  if (loadingFixtures || loadingWatchlists) {
    return (
      <div className="goals-saved">
        <div className="goals-loading">
          <div className="loading-spinner" />
          <p>Loading saved fixtures...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="goals-saved">
      {/* Header */}
      <div className="goals-saved-header">
        <button className="goals-back-btn" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>
        <h1>Saved Fixtures</h1>
      </div>

      {/* Watchlists */}
      {watchlists && watchlists.length > 0 && (
        <div className="goals-watchlists">
          <h3>Watchlists</h3>
          <div className="goals-watchlists-grid">
            {watchlists.map((wl) => (
              <div key={wl.id} className="goals-watchlist-card">
                <span className="goals-watchlist-name">{wl.name}</span>
                <span className="goals-watchlist-count">{wl.fixture_count} fixtures</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Saved Fixtures */}
      <div className="goals-saved-list">
        <h3>All Saved</h3>
        {savedFixtures && savedFixtures.length > 0 ? (
          <div className="goals-saved-items">
            {savedFixtures.map((saved) => (
              <div
                key={saved.id}
                className="goals-saved-item"
                onClick={() => onSelectFixture(saved.fixture_id)}
              >
                <span className="goals-saved-fixture-id">Fixture #{saved.fixture_id}</span>
                {saved.notes && <span className="goals-saved-notes">{saved.notes}</span>}
                {saved.target_market && (
                  <span className="goals-saved-market">{saved.target_market}</span>
                )}
                <span className="goals-saved-date">
                  Saved {new Date(saved.saved_at).toLocaleDateString()}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="goals-empty-state">
            <p>No saved fixtures yet</p>
            <button onClick={onBack}>Browse fixtures</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default GoalsSavedFixtures;
